module.exports = __webpack_public_path__ + "static/STG20_Mobile_960_Module4_TopImage-3ab4259ad3c5ada443a5ea5909efde18.jpg";